import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { logger } from 'Services/logger/logger';
import type { Nullable } from 'Types/utils';
import type { VehicleListItem } from 'Types/vehicle';

import { selectedVehicleFetcher } from './useFetchSelectedVehicle.helpers';

const useFetchSelectedVehicle = (vehicleId?: VehicleListItem['id']): UseQueryResult<Nullable<VehicleListItem[]>> =>
	useQuery({
		onError: (error: AxiosError) => {
			const message = `There was an issue with fetching selected vehicle ${vehicleId}`;

			logger.error({
				context: { extra: { info: message } },
				error,
				message,
				scope: 'useFetchSelectedVehicle',
			});
		},
		queryFn: () => selectedVehicleFetcher(vehicleId),
		queryKey: ['selectedVehicle', vehicleId],
	});

export default useFetchSelectedVehicle;
